import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from '@mindpal-co/mindpal-ui';
import { X } from 'lucide-react';
import type { FC } from 'react';
import { useState } from 'react';

import Button from '@/components/Button';
import Text from '@/components/Text';
import { TooltipContent } from '@/components/ui/tooltip';
import { useExternalCandidate } from '@/hooks/useExternalCandidate';
import { useFetchGithubData } from '@/hooks/useFetchGithubData';

type Props = {
  profileId: number;
  isLoading: boolean;
};

const UpdateGithubDataButton: FC<Props> = ({ profileId, isLoading }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // let timeout: NodeJS.Timeout | null = null;

  const { data } = useExternalCandidate(profileId, {
    staleTime: 1000 * 60 * 10,
  });

  const { mutate, isLoading: isMutationLoading } = useFetchGithubData(
    profileId,
    {
      onSuccess: () => {
        // if (
        //   JSON.stringify(response.githubProfile) ===
        //   JSON.stringify(data?.githubProfile)
        // ) {
        //   setTooltipOpen(true);
        //   timeout = setTimeout(() => {
        //     setTooltipOpen(false);
        //   }, 5 * 1000);
        // }
      },
    }
  );
  return (
    <TooltipProvider>
      <Tooltip open={tooltipOpen}>
        <TooltipTrigger asChild>
          <Button
            disabled={!data?.githubUrl}
            isLoading={isLoading || isMutationLoading}
            onClick={() => mutate()}
            size="long"
            variant="primaryLight"
            className="text-neutral-0"
          >
            {data?.githubProfile ? 'Update' : 'Download'} data from GitHub
          </Button>
        </TooltipTrigger>
        <TooltipContent
          sideOffset={8}
          showArrow={false}
          side="bottom"
          className="w-[17rem] rounded-lg text-neutral-1000"
        >
          <X
            onClick={() => {
              setTooltipOpen(false);
              // if (timeout) clearTimeout(timeout);
            }}
            className="absolute right-2 top-2 cursor-pointer"
            size={18}
          />
          <Text variant="body-small" className="font-semibold">
            No Updates Available
          </Text>
          <Text variant="body-small">
            It looks like all the candidate&apos;s information from GitHub is
            already up to date! No new data has been found since the last
            update.
          </Text>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default UpdateGithubDataButton;
